export const Months = [
    { id: 1, subName: 'Jan', name: 'January' },
    { id: 2, subName: 'Feb', name: 'February' },
    { id: 3, subName: 'Mar', name: 'March' },
    { id: 4, subName: 'Apr', name: 'April' },
    { id: 5, subName: 'May', name: 'May' },
    { id: 6, subName: 'Jun', name: 'June' },
    { id: 7, subName: 'Jul', name: 'July' },
    { id: 8, subName: 'Aug', name: 'August' },
    { id: 9, subName: 'Sep', name: 'September' },
    { id: 10, subName: 'Oct', name: 'October' },
    { id: 11, subName: 'Nov', name: 'November' },
    { id: 12, subName: 'Dec', name: 'December' },
  ]
  